import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule} from '@angular/platform-browser';
import { ApmService } from '@elastic/apm-rum-angular';
import { ToastNoAnimation, ToastNoAnimationModule, ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppCommonModule } from './common-module/app-common.module';
import { DirectivesModule } from './directives/directives.module';
import { APIURLs } from './services/api-urls';
import { OnboardErrorHandler } from './services/error-handler/error-handler.service';
import { CommonService } from './services/rest/common.service';
import { OnboardingService } from './services/rest/onboarding.service';
import { RestInterceptor } from './services/rest/rest-interceptor';
import { UtilsService } from './utils/utils.service';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


@NgModule({
  declarations: [
    AppComponent,
    FileUploadComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule, DirectivesModule,
    AppCommonModule,
    ToastNoAnimationModule,
    ToastrModule.forRoot({
      toastComponent: ToastNoAnimation,
      positionClass: 'toast-bottom-right',
      progressBar: true,
      preventDuplicates: true,
      progressAnimation: 'increasing',
      timeOut: 2000,
      maxOpened: 1,
      autoDismiss: true
    }),
    //ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    UtilsService,
    OnboardingService,
    CommonService,
    OnboardErrorHandler,
    RestInterceptor,
    { provide: ErrorHandler, useClass: OnboardErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: RestInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(service: ApmService, urls: APIURLs) {
    let serviceName = location.hostname.indexOf('accounts.choiceindia.com') > -1 ? 'OB_FE_LIVE' :
      location.hostname.indexOf('uat-pwa.choicetechlab.com') > -1 ? 'OB_FE_UAT' : 'OB_FE_LOCALHOST'
    const apm = service.init({
      serviceName: serviceName,
      serverUrl: 'https://apm.choicetechlab.com/',
      release: urls.getVersion()
    })
  }
}
